import { IIconProps } from 'native-base';
import { ClearIcon } from '../icons/clear';
import { CloudyIcon } from '../icons/cloudy';
import { MistIcon } from '../icons/mist';
import { ShowersIcon } from '../icons/showers';
import { RainIcon } from '../icons/rain';
import { SnowIcon } from '../icons/snow';
import { ThunderstormIcon } from '../icons/thunderstorm';
import { OpenMeteoWeatherCode } from '../types';

type WeatherIconProps = IIconProps & {
  code?: OpenMeteoWeatherCode;
  isDay?: boolean;
};

export const WeatherIcon = ({ code, isDay = false, ..._props }: WeatherIconProps) => {
  const fill = isDay ? '#EC6E4C' : undefined;
  if (typeof code !== 'number') return null;
  // Clear
  if (code === 0) return <ClearIcon fill={fill} {..._props} />;
  // Cloudy
  if ([1, 2, 3].includes(code)) return <CloudyIcon {..._props} />;
  // Mist/Fog
  if ([45, 48].includes(code)) return <MistIcon {..._props} />;
  // Drizzle
  if ([51, 53, 55, 56, 57].includes(code)) return <ShowersIcon fill={fill} {..._props} />;
  // Rain
  if ([61, 63, 65, 66, 67].includes(code)) return <RainIcon fill={fill} {..._props} />;
  // Snow
  if ([71, 73, 75, 77].includes(code)) return <SnowIcon {..._props} />;
  // Showers (rain or snow showers)
  if ([80, 81, 82, 85, 86].includes(code)) return <ShowersIcon fill={fill} {..._props} />;
  // Thunderstorm
  if ([95, 96, 99].includes(code)) return <ThunderstormIcon {..._props} />;

  return null;
};
